import React, { useEffect, useState, useRef } from 'react';
import './pay.css';
import axios from 'axios';
import { useNavigate , Link } from 'react-router-dom';
import API_BASE from "../api/api";
import toast from "react-hot-toast";


const CheckoutPage = () => {
  const [address, setAddress] = useState(null);
  const [cart, setCart] = useState([]);
  const [userEmail, setUserEmail] = useState("");
  const [editing, setEditing] = useState(false);
  const [editAddress, setEditAddress] = useState({
    id: '',
    name: '',
    phone: '',
    alternatePhone: '',
    address: '',
    landmark: '',
    locality: '',
    city: '',
    state: '',
    pincode: '',
    email: ''
  });
  const [pincode, setPincode] = useState('');
  const [localities, setLocalities] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const finalOrderIdRef = useRef(null);
  const paymentDoneRef = useRef(false);


  const isValidIndianMobile = (value) => {
    if (!value) return true;
    return /^[6-9]\d{9}$/.test(value);
  };


  useEffect(() => {
  const pending = localStorage.getItem("pending_order");

  if (pending) {
    const data = JSON.parse(pending);

   if (data.razorpay_payment_id && data.razorpay_order_id) {
      axios.post(
        `${API_BASE}/save_order.php`,
        data,
        { withCredentials: true }
      )
      .then(res => {
        if (res.data.success) {
          localStorage.removeItem("pending_order");
        }
      })
      .catch(() => {});
    }
  }
}, []);

  /* ================= FETCH ADDRESS ================= */
useEffect(() => {
  const fetchUserAddress = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/getaddress.php`,
        { withCredentials: true }
      );

      console.log("ADDRESS:", res.data);

      if (res.data.status === "success" && res.data.data.length > 0) {
        const addr = res.data.data[0];

        const normalized = {
          ...addr,
          alternatePhone: addr.alternate_phone || '',
          landmark: addr.landmark || ''
        };

        setAddress(normalized);
        setEditAddress(normalized);
        setUserEmail(addr.email || '');
        setPincode(addr.pincode || '');
      }

    } catch (err) {
      console.error("Address fetch error:", err);
    }
  };

  fetchUserAddress();
}, []);

  /* ================= FETCH CART ================= */
useEffect(() => {
  const fetchCart = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/getcart.php`,
        { withCredentials: true }
      );

      console.log("CART STRUCTURE:", res.data.data);

      if (res.data.status === "success") {
        setCart(res.data.data);
      }

    } catch (err) {
      console.error("Cart fetch error:", err);
    }
  };

  fetchCart();

  const handleCartUpdate = () => fetchCart();
  window.addEventListener('cartUpdated', handleCartUpdate);

  return () => window.removeEventListener('cartUpdated', handleCartUpdate);
}, []);

const getTotalPrice = () =>
  cart.reduce((t, i) => {
    const price = parseFloat(String(i.price).replace(/[^\d.]/g, '')) || 0;
    const qty = parseInt(i.quantity || 1);
    return t + price * qty;
  }, 0);

  const getTotalSavings = () =>
    cart.reduce(
      (t, i) =>
        t + ((i.originalPrice || i.price) - i.price) * i.quantity,
      0
    );


const retrySave = async (data, retries = 5) => {

  console.log("Retrying order...", data); // 🔥 ADD HERE

  try {
    const res = await axios.post(
      `${API_BASE}/save_order.php`,
      data,
      { withCredentials: true }
    );

    if (res.data.success) {
      console.log("Order recovered successfully"); // optional
      localStorage.removeItem("pending_order");
      return;
    }
  } catch (err) {
    console.log("Retry error:", err); // optional
  }

  if (retries > 0) {
    setTimeout(() => retrySave(data, retries - 1), 3000);
  }
};

  /* ================= SAVE ADDRESS ================= */
const handleSaveAddress = async () => {
  try {
    const res = await axios.post(
      `${API_BASE}/saveAddress.php`,
      editAddress,
      { withCredentials: true }
    );

    if (res.data.status === "success") {
      toast.success("Address saved successfully");
      setAddress(editAddress);
      setEditing(false);
    } else {
      toast.error(res.data.message);
    }

  } catch (err) {
    console.error(err);
    toast.error("Error saving address");
  }
};

  /* ================= PINCODE LOOKUP ================= */
/* ================= PINCODE LOOKUP ================= */
useEffect(() => {

  const fetchLocationByPincode = async () => {

    if (pincode.length !== 6) {

      setLocalities([]);

      setEditAddress(prev => ({
        ...prev,
        city: '',
        state: '',
        locality: ''
      }));

      return;
    }

    try {

      console.log("FETCHING PINCODE:", pincode);

      const res = await fetch(
        `${API_BASE}/getPincode.php?pincode=${pincode}`
      );

      const data = await res.json();

      console.log("PINCODE RESPONSE:", data);

      if (
        !Array.isArray(data) ||
        data[0]?.Status !== "Success" ||
        !data[0]?.PostOffice
      ) {
        throw new Error("Invalid response");
      }

      const po = data[0].PostOffice;

      const locs = [
        ...new Set(
          po.map(p => p.Name?.trim()).filter(Boolean)
        )
      ];

      console.log("LOCALITIES:", locs);

      setLocalities(locs);

      setEditAddress(prev => ({
        ...prev,
        city: po[0]?.District || '',
        state: po[0]?.State || '',
        locality: locs[0] || '',
        pincode
      }));

    } catch (err) {

      console.error("Pincode error:", err);

      setLocalities([]);

      setEditAddress(prev => ({
        ...prev,
        city: '',
        state: '',
        locality: ''
      }));
    }
  };

  fetchLocationByPincode();

}, [pincode]);

const handlePlaceOrder = async () => {

  if (loading) return;
  setLoading(true);

  // ✅ VALIDATION
  if (!userEmail) {
    toast.error("Please login again");
    setLoading(false);
    navigate("/login");
    return;
  }

  if (!address) {
    toast.error("Please add delivery address");
    setLoading(false);
    return;
  }

  if (cart.length === 0) {
    toast.error("Your cart is empty");
    setLoading(false);
    return;
  }

  const totalAmount = Math.round(getTotalPrice());

  if (!totalAmount || totalAmount <= 0 || isNaN(totalAmount)) {
    toast.error("Invalid cart amount");
    setLoading(false);
    return;
  }

  try {
    const itemsPayload = cart.map(item => ({
      id: item.product_id || item.id,
      quantity: item.quantity
    }));

    const orderPayload = {
      amount: totalAmount,
      name: address.name,
      email: userEmail || address.email || '',
      phone: address.phone,
      address: address.address,
      landmark: address.landmark || '',
      locality: address.locality || '',
      city: address.city,
      state: address.state,
      pincode: address.pincode,
      items: itemsPayload
    };

    // ✅ CREATE RAZOR ORDER & PRE-SAVE TO DB
    const res = await axios.post(
      `${API_BASE}/razor.php`,
      orderPayload,
      { withCredentials: true }
    );

    if (!res.data.success) {
      toast.error(res.data.error || "Order initialization failed");
      setLoading(false);
      return;
    }

    const razorpayOrderId = res.data.order_id;

    // 🔥 LOCAL BACKUP
    const backupOrder = {
      ...orderPayload,
      razorpay_order_id: razorpayOrderId,
      razorpay_payment_id: ""
    };

    localStorage.setItem("pending_order", JSON.stringify(backupOrder));

    const options = {
      key: "rzp_live_6BKUe49eCrDsJN",
      amount: Math.round(totalAmount * 100),
      currency: "INR",
      name: "Sangit Shree Prakashan",
      order_id: razorpayOrderId,
      prefill: {
        name: address.name,
        email: userEmail || address.email || '',
        contact: address.phone
      },
      notes: {
        name: address.name,
        phone: address.phone,
        email: userEmail || address.email || ''
      },

handler: async function (response) {

  if (paymentDoneRef.current) return;
  paymentDoneRef.current = true;

  try {

    // 🔥 STEP 1: GET BACKUP
    const pending = JSON.parse(localStorage.getItem("pending_order") || "{}");

    // 🔥 STEP 2: UPDATE PAYMENT ID
    pending.razorpay_payment_id = response.razorpay_payment_id;
    localStorage.setItem("pending_order", JSON.stringify(pending));

    // 🔒 GUARD
    if (!pending.razorpay_payment_id || !pending.razorpay_order_id) {
      console.error("Missing payment data", pending);
      setLoading(false);
      return;
    }

    // ✅ VERIFY PAYMENT
    const verifyRes = await axios.post(
      'https://sangitshreeprakashan.com/backend/api/verify_payment.php',
      {
        razorpay_order_id: response.razorpay_order_id,
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_signature: response.razorpay_signature
      },
      { withCredentials: true }
    );

    if (!verifyRes.data.success) {
      console.error("Verification failed", pending);
      toast.error("Payment verification failed");
      setLoading(false);
      return;
    }

    // ✅ SAVE ORDER
    const orderRes = await axios.post(
      'https://sangitshreeprakashan.com/backend/api/save_order.php',
      pending,
      { withCredentials: true }
    );

    console.log("SAVE ORDER RESPONSE:", orderRes.data);

    if (!orderRes.data.success) {
      console.error("Order save failed:", orderRes.data);
      toast.error("Order failed. Please contact support");
      setLoading(false);
      return;
    }

    // ✅ SUCCESS
    localStorage.removeItem("pending_order");

    await axios.post(
      'https://sangitshreeprakashan.com/backend/api/clearcart.php',
      {},
      { withCredentials: true }
    );

    setCart([]);
    window.dispatchEvent(new Event('cartUpdated'));

    toast.success("Order placed successfully");
    setLoading(false);
    navigate('/');

  } catch (err) {

    console.error("SAVE ERROR:", err);

    const pending = JSON.parse(localStorage.getItem("pending_order") || "{}");

    // 🔥 SAFE RETRY (ONLY IF PAYMENT EXISTS)
    if (pending.razorpay_payment_id && pending.razorpay_order_id) {
      console.log("Retrying order...", pending);
      retrySave(pending);
    }

    toast.loading("Retrying order save...");
    setLoading(false);

  } finally {
    // 🔥 CRITICAL FIX
    paymentDoneRef.current = false;
  }
}
    };

    const rzp = new window.Razorpay(options);

    rzp.on('payment.failed', function () {
      toast.error("Payment failed");
      setLoading(false);
    });

    rzp.open();

  } catch (err) {
    console.error(err);
    toast.error("Payment initialization failed");
    setLoading(false);
  }
};


  return (
    <div className="checkout-wrapper">
      <div className="checkout-container">
        
        <div className="address-box">
          <button
  type="button"
  className="back-btn"
  onClick={() => navigate("/cart")}
>
  ← Back
</button>
          <h3>Deliver To</h3>

          {!editing ? (
            <>
              {address ? (
<>
  <div className="delivery-user">
    <span className="delivery-name">
      {address.name}
    </span>

    <span className="delivery-phone">
      +91 {address.phone}
    </span>
  </div>

  <div className="delivery-address">
    {address.address}, {address.locality},
    {" "}
    {address.city}, {address.state} - {address.pincode}
  </div>

  {address.landmark && (
    <div className="delivery-meta">
      <span className="meta-label">Landmark:</span>
      <span>{address.landmark}</span>
    </div>
  )}

  {address.alternatePhone && (
    <div className="delivery-meta">
      <span className="meta-label">Alternate Phone:</span>
      <span>+91 {address.alternatePhone}</span>
    </div>
  )}

  <div className="delivery-meta">
    <span className="meta-label">Email:</span>
    <span>{userEmail}</span>
  </div>
  <span
  className="edit-address-btn"
  onClick={() => setEditing(true)}
>
  Edit Address
</span>
  </>
              ) : (
                <button onClick={() => setEditing(true)}>Add Address</button>
              )}
            </>
          ) : (
<div className="edit-address-form">

  <div className="form-row">

    <div className="input-group">
      <label>Full Name</label>
      <input
        placeholder="Enter full name"
        value={editAddress.name}
        onChange={e =>
          setEditAddress({ ...editAddress, name: e.target.value })
        }
      />
    </div>

    <div className="input-group">
      <label>Phone Number</label>
      <input
        placeholder="Enter phone number"
        value={editAddress.phone}
        onChange={e =>
          setEditAddress({ ...editAddress, phone: e.target.value })
        }
      />
    </div>

  </div>

  <div className="form-row">

    <div className="input-group">
      <label>Alternate Phone</label>
      <input
        placeholder="Optional"
        maxLength={10}
        value={editAddress.alternatePhone}
        onChange={e =>
          setEditAddress({
            ...editAddress,
            alternatePhone: e.target.value.replace(/\D/g, '')
          })
        }
      />
    </div>

    <div className="input-group">
      <label>Landmark</label>
      <input
        placeholder="Optional"
        value={editAddress.landmark}
        onChange={e =>
          setEditAddress({
            ...editAddress,
            landmark: e.target.value
          })
        }
      />
    </div>

  </div>

  <div className="input-group">
    <label>Full Address</label>
    <textarea
      placeholder="Enter full delivery address"
      value={editAddress.address}
      onChange={e =>
        setEditAddress({
          ...editAddress,
          address: e.target.value
        })
      }
    />
  </div>

  <div className="form-row">

    <div className="input-group">
      <label>Pincode</label>
      <input
        placeholder="Enter pincode"
        maxLength={6}
        value={pincode}
        onChange={e =>
  setPincode(
    e.target.value.replace(/\D/g, '').slice(0, 6)
  )
}
      />
    </div>

    <div className="input-group">
      <label>Locality</label>
      <select
        value={editAddress.locality}
        onChange={e =>
          setEditAddress({
            ...editAddress,
            locality: e.target.value
          })
        }
      >
        <option value="">Select Locality</option>

        {localities.map((l, i) => (
          <option key={i}>{l}</option>
        ))}
      </select>
    </div>

  </div>

  <div className="form-row">

    <div className="input-group">
      <label>City</label>
      <input value={editAddress.city} readOnly />
    </div>

    <div className="input-group">
      <label>State</label>
      <input value={editAddress.state} readOnly />
    </div>

  </div>

  <div className="edit-actions">

    <button
      className="save-address-btn"
      onClick={handleSaveAddress}
    >
      Save Address
    </button>

    <span
      className="cancel-edit"
      onClick={() => setEditing(false)}
    >
      Cancel
    </span>

  </div>

</div>
          )}
        </div>

        <div className="order-section">
          <h3 className="section-title">ORDER SUMMARY</h3>
          {cart.map((item, i) => (
<div className="order-item" key={i}>

  <Link to={`/book/${item.product_id || item.id}`}>
    <img
      src={item.img || item.image}
      alt={item.name}
      className="item-img"
      style={{ cursor: "pointer" }}
    />
  </Link>

  <div className="item-details">
    <Link
      to={`/book/${item.product_id || item.id}`}
      style={{
        textDecoration: "none",
        color: "inherit"
      }}
    >
      <h4 style={{ cursor: "pointer" }}>
        {item.name}
      </h4>
    </Link>

    <p>Quantity: {item.quantity}</p>
    <span>₹{item.price}</span>
  </div>
</div>
          ))}
        </div>

        <div className="price-box">
          <h3>PRICE DETAILS</h3>
          <div className="price-line">
            <span>Price ({cart.length} items)</span>
            <span>₹{getTotalPrice()}</span>
          </div>
          <hr />
          <div className="total-line">
            <strong>Total Payable</strong>
            <strong>₹{getTotalPrice()}</strong>
          </div>
          <div className="savings">
            You saved ₹{getTotalSavings()}
          </div>
<button 
  className="place-order-btn" 
  onClick={handlePlaceOrder}
  disabled={loading}
>
  {loading ? "Processing..." : "Place Order"}
</button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;